// extracted by mini-css-extract-plugin
export default {"container":"Clipboard_container__3mOXs","inner_sub_heading":"Clipboard_inner_sub_heading__CQCqA","card":"Clipboard_card__tK8Iy"};